/* Great Lakes Lavender Farm — Saved & Compare UX layer.
   Works on top of the Saved & Compare app (it keeps owning the data and account sync):
   - header heart/compare open a shortlist drawer instead of jumping to a new page
   - compare tray at the bottom of the screen while shopping
   - product-page buttons show clear "Saved" / "Comparing" states
   - product-card buttons float on the image
   - toasts get a helpful action link
   - design-v1: a Lists tab (saved lists / boards, from gllf-boards-v1.js), a side-by-side quick compare,
     "Compare is full" asks which one to swap instead of silently dropping the oldest, and product-page
     Save/Compare always record the option that is selected right now (name, price, picture, stock).
   All changes go through the app's own buttons, so account sync keeps working. */
(function () {
  'use strict';
  if (window.__gllfSavedPlus) return;
  window.__gllfSavedPlus = true;

  var KEY = 'gllf_saved_v1', COMPARE = 'gllf_compare_v1', MAX_COMPARE = 4;
  /* gllf-ui-polish-v1: clearer heart + side-by-side compare icon (the old arrows read as "sort") */
  var ICON = {
    heart: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/></svg>',
    compare: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="7.5" height="16" rx="2"/><rect x="13.5" y="4" width="7.5" height="16" rx="2"/><path d="M6 9h1.5M6 12.5h1.5M16.5 9H18M16.5 12.5H18"/></svg>',
    lists: '<svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7.5" height="9" rx="2"/><rect x="13.5" y="3" width="7.5" height="5.5" rx="2"/><rect x="3" y="15" width="7.5" height="6" rx="2"/><rect x="13.5" y="11.5" width="7.5" height="9.5" rx="2"/></svg>'
  };

  function read(k) { try { var v = JSON.parse(localStorage.getItem(k)); return Array.isArray(v) ? v : []; } catch (e) { return []; } }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(c) { return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format((+c || 0) / 100); }
  function img(u, w) { if (!u) return ''; u = String(u); if (u.indexOf('//') === 0) u = 'https:' + u; return u.replace(/(\.(jpe?g|png|webp|gif))(\?|$)/i, '_' + (w || 200) + 'x$1$3'); }
  function onComparePage() { return /^\/pages\/compare/.test(location.pathname); }

  /* Run an add/remove through the app's own delegated click handler (keeps remote sync). */
  function appToggle(item, kind) {
    var host = document.createElement('div');
    host.setAttribute('data-gllf-product-actions', '');
    host.hidden = true;
    var d = host.dataset;
    d.productGid = item.productId || ''; d.variantGid = item.variantId || ''; d.productHandle = item.productHandle || '';
    d.productTitle = item.productTitle || item.title || ''; d.variantTitle = item.variantTitle || ''; d.productImage = item.imageUrl || '';
    d.priceCents = String(item.priceCents || 0); d.ruleClass = item.ruleClass || 'unknown'; d.available = String(item.available !== false);
    var b = document.createElement('button'); b.type = 'button';
    b.setAttribute(kind === 'compare' ? 'data-gllf-compare' : 'data-gllf-save', '');
    host.appendChild(b); document.body.appendChild(host);
    b.click();
    setTimeout(function () { host.remove(); }, 50);
  }

  /* ---------- Header badges ---------- */
  function initHeader() {
    document.querySelectorAll('.gllf-header-action').forEach(function (a) {
      var href = a.getAttribute('href') || '';
      var kind = /compare/.test(href) ? 'compare' : /wishlist/.test(href) ? 'wishlist' : '';
      if (!kind || a.dataset.spKind) return;
      a.dataset.spKind = kind;
      a.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0) return;
        if (onComparePage() && kind === 'compare') return;
        e.preventDefault();
        openDrawer(kind);
      });
    });
    syncBadges(false);
  }
  var lastCounts = {};
  function syncBadges(bump) {
    var counts = { wishlist: read(KEY).length, compare: read(COMPARE).length };
    document.querySelectorAll('[data-gllf-count]').forEach(function (el) {
      var k = el.getAttribute('data-gllf-count'), n = counts[k] || 0;
      if (el.textContent !== String(n)) el.textContent = String(n);
      el.classList.toggle('sp-zero', n === 0);
      if (bump && lastCounts[k] !== undefined && lastCounts[k] !== n && n > 0) {
        el.classList.remove('sp-bump'); void el.offsetWidth; el.classList.add('sp-bump');
      }
      var a = el.closest('.gllf-header-action'); if (a) a.classList.toggle('sp-has-items', n > 0);
    });
    lastCounts = counts;
  }

  /* ---------- Product buttons (labels + pop) ---------- */
  function decorateButtons(scope) {
    (scope || document).querySelectorAll('.gllf-saved-actions:not(.gllf-saved-actions--card) .gllf-saved-button[data-gllf-save], .gllf-saved-actions:not(.gllf-saved-actions--card) .gllf-saved-button[data-gllf-compare]').forEach(function (b) {
      if (b.dataset.spReady) return; b.dataset.spReady = '1';
      var isSave = b.hasAttribute('data-gllf-save');
      var label = b.querySelector('.sp-label');
      if (!label) {
        var text = '';
        Array.prototype.slice.call(b.childNodes).forEach(function (n) {
          if (n.nodeType === 3 && n.textContent.trim()) { text += n.textContent.trim(); n.remove(); }
          else if (n.nodeType === 1 && !n.matches('svg,.gllf-icon') && !n.classList.contains('visually-hidden') && n.textContent.trim()) { text += n.textContent.trim(); n.remove(); }
        });
        label = document.createElement('span'); label.className = 'sp-label'; b.appendChild(label);
        b.dataset.spOff = text || (isSave ? 'Save to Wishlist' : 'Add to Compare');
      }
      var setLabel = function () {
        var on = b.getAttribute('aria-pressed') === 'true';
        label.textContent = on ? (isSave ? 'Saved' : 'Comparing') : b.dataset.spOff;
      };
      setLabel();
      new MutationObserver(setLabel).observe(b, { attributes: true, attributeFilter: ['aria-pressed'] });
    });
    (scope || document).querySelectorAll('.gllf-saved-actions--card').forEach(function (host) {
      if (host.dataset.spReady) return;
      var card = host.closest('.card-wrapper, .card, [data-gllf-product-card]');
      var media = card && (card.querySelector('.card__inner') || card.querySelector('.card__media'));
      if (!media) return;
      host.dataset.spReady = '1';
      media.classList.add('sp-card-host');
      media.appendChild(host);
      host.classList.add('sp-overlay');
      host.querySelectorAll('.gllf-saved-button').forEach(function (b) {
        var save = b.hasAttribute('data-gllf-save');
        var tip = function () { var on = b.getAttribute('aria-pressed') === 'true'; b.dataset.spTip = save ? (on ? 'Saved' : 'Save') : (on ? 'In compare' : 'Compare'); };
        tip(); new MutationObserver(tip).observe(b, { attributes: true, attributeFilter: ['aria-pressed'] });
      });
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.gllf-saved-button');
    if (!b) return;
    b.classList.remove('sp-pop'); void b.offsetWidth; b.classList.add('sp-pop');
  }, true);

  /* ---------- Toast actions ---------- */
  function initToasts() {
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (!n.classList || !n.classList.contains('gllf-toast') || n.querySelector('.sp-toast-action')) return;
          var t = n.textContent || '', a = null;
          if (/Saved to Wishlist/i.test(t)) { a = ['View saved', 'wishlist']; }
          else if (/Added to Compare/i.test(t)) { var c = read(COMPARE).length; a = [c >= 2 ? 'Compare ' + c + ' now' : 'View compare', 'compare']; }
          if (!a) return;
          var link = document.createElement('a'); link.className = 'sp-toast-action'; link.href = a[1] === 'compare' ? '/pages/compare' : '/pages/wishlist'; link.textContent = a[0];
          if (!(a[1] === 'compare' && read(COMPARE).length >= 2)) link.addEventListener('click', function (e) { e.preventDefault(); openDrawer(a[1]); });
          n.appendChild(link);
          if (a[1] === 'wishlist' && window.GLLFBoards && window.GLLFBoards.decorateToast) window.GLLFBoards.decorateToast(n);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- Drawer ---------- */
  var root, drawer, tab = 'wishlist', lastFocus, boardId = '', diffOnly = false;
  function boardsOn() { return !!(window.GLLFBoards && window.GLLFBoards.ready); }
  function tabsShown() { return boardsOn() ? ['wishlist', 'lists', 'compare'] : ['wishlist', 'compare']; }
  function buildDrawer() {
    if (root) return;
    root = document.createElement('div'); root.className = 'sp-drawer-root'; root.hidden = true;
    root.innerHTML =
      '<div class="sp-overlay-bg" data-sp-close></div>' +
      '<aside class="sp-drawer" role="dialog" aria-modal="true" aria-labelledby="SPTitle">' +
        '<div class="sp-drawer__head"><div><h2 class="sp-drawer__title" id="SPTitle">Your shortlist</h2><p class="sp-drawer__sub">Saved on this device and synced to your account when signed in.</p></div>' +
        '<button class="sp-x" type="button" data-sp-close aria-label="Close">×</button></div>' +
        '<div class="sp-tabs" role="tablist" aria-label="Shortlist">' +
          '<button type="button" role="tab" id="SPTabW" aria-controls="SPBody" data-sp-tab="wishlist">' + ICON.heart.replace('<svg', '<svg width="18" height="18"') + ' Saved <span class="sp-n" data-sp-n="wishlist">0</span></button>' +
          '<button type="button" role="tab" id="SPTabL" aria-controls="SPBody" data-sp-tab="lists" hidden>' + ICON.lists + ' Lists <span class="sp-n" data-sp-n="lists"></span></button>' +
          '<button type="button" role="tab" id="SPTabC" aria-controls="SPBody" data-sp-tab="compare">' + ICON.compare.replace('<svg', '<svg width="18" height="18"') + ' Compare <span class="sp-n" data-sp-n="compare">0</span></button>' +
        '</div>' +
        '<div class="sp-drawer__body" id="SPBody" role="tabpanel" tabindex="-1"></div>' +
        '<div class="sp-drawer__foot" data-sp-foot></div>' +
      '</aside>';
    document.body.appendChild(root);
    drawer = root.querySelector('.sp-drawer');
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-sp-close]')) { closeDrawer(); return; }
      var t = e.target.closest('[data-sp-tab]'); if (t) { tab = t.dataset.spTab; boardId = ''; render(); return; }
      if (e.target.closest('[data-sp-diff]')) { diffOnly = !diffOnly; render(); return; }
      var act = e.target.closest('[data-sp-act]'); if (!act) return;
      var kind = act.dataset.spList, id = act.dataset.spId, list = read(kind === 'compare' ? COMPARE : KEY);
      var item = list.filter(function (x) { return x.variantId === id; })[0]; if (!item) return;
      if (act.dataset.spAct === 'remove') {
        var li = act.closest('.sp-item'); if (li) li.classList.add('is-leaving');
        setTimeout(function () { appToggle(item, kind); }, 180);
      } else if (act.dataset.spAct === 'to-compare') {
        appToggle(item, 'compare');
      } else if (act.dataset.spAct === 'to-saved') {
        appToggle(item, 'wishlist');
      }
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeDrawer(); return; }
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        var tabBtn = e.target.closest('[data-sp-tab]');
        if (tabBtn) {
          var order = tabsShown(), i = order.indexOf(tab);
          tab = order[(i + (e.key === 'ArrowRight' ? 1 : order.length - 1)) % order.length]; boardId = ''; render(); root.querySelector('[data-sp-tab="' + tab + '"]').focus();
        }
      }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.slice.call(drawer.querySelectorAll('a[href],button:not([disabled])')).filter(function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });
  }
  function itemHtml(x, kind) {
    var inCompare = read(COMPARE).some(function (c) { return c.variantId === x.variantId; });
    var inSaved = read(KEY).some(function (c) { return c.variantId === x.variantId; });
    var title = x.productTitle || x.title || 'Product';
    var href = x.productHandle ? '/products/' + encodeURIComponent(x.productHandle) : '#';
    var avail = x.available === false ? '<span class="sp-chip sp-chip--pre">Pre-order / notify</span>' : '<span class="sp-chip sp-chip--ok">Available</span>';
    var other = kind === 'wishlist'
      ? (inCompare ? '' : '<button type="button" class="sp-link-btn" data-sp-act="to-compare" data-sp-list="wishlist" data-sp-id="' + esc(x.variantId) + '">⇄ Compare</button>')
      : (inSaved ? '' : '<button type="button" class="sp-link-btn" data-sp-act="to-saved" data-sp-list="compare" data-sp-id="' + esc(x.variantId) + '">♡ Save</button>');
    return '<li class="sp-item">' +
      (x.imageUrl ? '<img class="sp-item__img" src="' + esc(img(x.imageUrl, 200)) + '" alt="" width="84" height="84" loading="lazy">' : '<span class="sp-item__img" aria-hidden="true"></span>') +
      '<div class="sp-item__main">' +
        '<a class="sp-item__title" href="' + esc(href) + '">' + esc(title) + '</a>' +
        '<div class="sp-item__meta">' + (x.variantTitle && x.variantTitle !== 'Default Title' ? '<span>' + esc(x.variantTitle) + '</span>' : '') + avail + '</div>' +
        '<div class="sp-item__price">' + money(x.priceCents) + '</div>' +
        '<div class="sp-item__actions"><a class="sp-link-btn" href="' + esc(href) + '">View</a>' + other +
          '<button type="button" class="sp-link-btn sp-link-btn--quiet" data-sp-act="remove" data-sp-list="' + kind + '" data-sp-id="' + esc(x.variantId) + '" aria-label="Remove ' + esc(title) + '">Remove</button></div>' +
      '</div></li>';
  }
  /* ---------- Quick compare (side by side, in the drawer) ---------- */
  var ROWS = [
    ['Price', function (x) { return x.priceCents ? money(x.priceCents) : ''; }],
    ['Status', function (x) { return x.available === false ? 'Pre-order / notify' : 'Available'; }],
    ['Option', function (x) { return x.variantTitle && x.variantTitle !== 'Default Title' ? x.variantTitle : ''; }],
    ['Type', function (x) { return c(x).productType; }],
    ['Format', function (x) { return c(x).plantFormat; }],
    ['Hardiness zones', function (x) { return c(x).hardinessZones; }],
    ['Mature size', function (x) { return c(x).matureSize; }],
    ['Blooms', function (x) { return c(x).bloomSeason; }],
    ['Flower color', function (x) { return c(x).bloomColor; }],
    ['Sun', function (x) { return c(x).sunExposure; }]
  ];
  function c(x) { return x.comparison || {}; }
  function norm(v) { return String(v == null ? '' : v).trim().toLowerCase(); }
  function quickCompare(list) {
    var cols = list.slice(0, MAX_COMPARE);
    var rows = ROWS.map(function (r) { return { label: r[0], vals: cols.map(function (x) { return String(r[1](x) || ''); }) }; })
      .filter(function (r) { return r.vals.some(function (v) { return v; }); });
    var differs = function (r) { var f = norm(r.vals[0]); return r.vals.some(function (v) { return norm(v) !== f; }); };
    var nDiff = rows.filter(differs).length;
    var shown = diffOnly ? rows.filter(differs) : rows;
    var head = cols.map(function (x) {
      var href = x.productHandle ? '/products/' + encodeURIComponent(x.productHandle) : '#';
      return '<th scope="col"><div class="sp-qc__card">' +
        (x.imageUrl ? '<img src="' + esc(img(x.imageUrl, 240)) + '" alt="" width="96" height="96" loading="lazy">' : '<span class="sp-qc__ph" aria-hidden="true"></span>') +
        '<a href="' + esc(href) + '">' + esc(x.productTitle || 'Product') + '</a>' +
        '<button type="button" class="sp-qc__rm" data-sp-act="remove" data-sp-list="compare" data-sp-id="' + esc(x.variantId) + '" aria-label="Remove ' + esc(x.productTitle || 'item') + ' from compare">×</button></div></th>';
    }).join('');
    var empty = MAX_COMPARE - cols.length, pad = '';
    for (var i = 0; i < empty; i++) pad += '<th scope="col" class="sp-qc__open"><span>+</span><small>Tap ⇄ on any product</small></th>';
    var body = shown.map(function (r) {
      var d = differs(r);
      return '<tr class="' + (d ? 'is-diff' : '') + '"><th scope="row">' + esc(r.label) + '</th>' + r.vals.map(function (v) { return '<td>' + (v ? esc(v) : '<span class="sp-qc__na">—</span>') + '</td>'; }).join('') + (empty ? '<td colspan="' + empty + '"></td>' : '') + '</tr>';
    }).join('');
    return '<div class="sp-qc__bar"><span>' + (cols.length < 2 ? 'Add one more to see them side by side.' : nDiff ? nDiff + ' difference' + (nDiff === 1 ? '' : 's') + ' highlighted' : 'These match on everything we know') + '</span>' +
      (cols.length > 1 && rows.length ? '<button type="button" class="sp-switch" role="switch" aria-checked="' + diffOnly + '" data-sp-diff><i aria-hidden="true"></i>Only differences</button>' : '') + '</div>' +
      '<div class="sp-qc" role="region" aria-label="Quick compare" tabindex="0"><table class="sp-qc__t"><thead><tr><td></td>' + head + pad + '</tr></thead><tbody>' + body + '</tbody></table></div>';
  }

  function render() {
    if (!root) return;
    var saved = read(KEY), compared = read(COMPARE);
    if (tab === 'lists' && !boardsOn()) tab = 'wishlist';
    root.querySelector('[data-sp-n="wishlist"]').textContent = saved.length;
    root.querySelector('[data-sp-n="compare"]').textContent = compared.length + '/' + MAX_COMPARE;
    var lt = root.querySelector('[data-sp-tab="lists"]'); lt.hidden = !boardsOn();
    root.querySelector('.sp-tabs').classList.toggle('sp-tabs--3', boardsOn());
    if (boardsOn()) root.querySelector('[data-sp-n="lists"]').textContent = window.GLLFBoards.count();
    root.querySelectorAll('[data-sp-tab]').forEach(function (b) { b.setAttribute('aria-selected', b.dataset.spTab === tab ? 'true' : 'false'); b.tabIndex = b.dataset.spTab === tab ? 0 : -1; });
    var body = root.querySelector('#SPBody'), foot = root.querySelector('[data-sp-foot]');
    body.setAttribute('aria-labelledby', tab === 'compare' ? 'SPTabC' : tab === 'lists' ? 'SPTabL' : 'SPTabW');
    drawer.classList.toggle('sp-drawer--wide', tab === 'compare' && compared.length > 1);
    if (tab === 'lists') { window.GLLFBoards.render(body, foot, boardId, function (id) { boardId = id || ''; }); return; }
    var list = tab === 'compare' ? compared : saved;
    if (!list.length) {
      body.innerHTML = '<div class="sp-empty"><span class="sp-empty__icon">' + (tab === 'compare' ? ICON.compare : ICON.heart) + '</span>' +
        '<h3>' + (tab === 'compare' ? 'Nothing to compare yet' : 'No saved plants yet') + '</h3>' +
        '<p>' + (tab === 'compare' ? 'Tap the ⇄ button on up to 4 plants or products to see them side by side.' : 'Tap the ♡ on any plant or product to keep it here while you plan.') + '</p></div>';
      foot.innerHTML = '<a class="sp-btn" href="/pages/plant-finder">Find plants for my garden</a><a class="sp-btn sp-btn--ghost" href="/collections/live-plants">Browse live plants</a>';
      return;
    }
    if (tab === 'compare') {
      body.innerHTML = '<div class="sp-meter"><span>' + compared.length + ' of ' + MAX_COMPARE + ' slots</span><span class="sp-meter__bar"><i style="width:' + (compared.length / MAX_COMPARE * 100) + '%"></i></span></div>' + quickCompare(compared);
      foot.innerHTML = '<a class="sp-btn" href="/pages/compare"' + (compared.length < 2 ? ' aria-disabled="true"' : '') + '>Open full comparison</a>' +
        '<p class="sp-hint">' + (compared.length < 2 ? 'Add at least 2 to compare.' : compared.length >= MAX_COMPARE ? 'Compare is full. Adding another asks which one to swap out.' : 'Room for ' + (MAX_COMPARE - compared.length) + ' more.') + '</p>';
      return;
    }
    body.innerHTML = '<ul class="sp-list" role="list">' + list.slice().reverse().map(function (x) { return itemHtml(x, tab); }).join('') + '</ul>';
    foot.innerHTML = '<a class="sp-btn" href="/pages/wishlist">Open my saved list</a>' +
      (boardsOn() ? '<button type="button" class="sp-btn sp-btn--ghost" data-sp-tab="lists">' + ICON.lists + ' Organize into lists</button>' : '') +
      (compared.length >= 2 ? '<a class="sp-btn sp-btn--ghost" href="/pages/compare">Compare ' + compared.length + ' side by side</a>' : '');
  }
  function openDrawer(which, opts) {
    buildDrawer(); tab = which || tab; boardId = (opts && opts.board) || ''; render();
    lastFocus = document.activeElement;
    root.hidden = false; document.documentElement.classList.add('sp-lock');
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-open'); root.querySelector('[data-sp-tab="' + tab + '"]').focus(); }); });
  }
  function closeDrawer() {
    if (!root || root.hidden) return;
    root.classList.remove('is-open'); document.documentElement.classList.remove('sp-lock');
    setTimeout(function () { root.hidden = true; }, 320);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  window.GLLFShortlist = { open: openDrawer, close: closeDrawer, refresh: function () { if (root && !root.hidden) render(); }, toggle: appToggle, isOpen: function () { return !!(root && !root.hidden); } };

  /* ---------- Compare tray ---------- */
  var tray;
  function renderTray() {
    var list = read(COMPARE);
    var dismissed = false; try { dismissed = sessionStorage.getItem('sp-tray-hide') === String(list.length); } catch (e) {}
    var show = list.length > 0 && !onComparePage() && !/^\/(cart|checkouts|account)/.test(location.pathname) && !dismissed;
    if (!tray) {
      if (!show) return;
      tray = document.createElement('div'); tray.className = 'sp-tray'; tray.setAttribute('role', 'region'); tray.setAttribute('aria-label', 'Compare tray');
      document.body.appendChild(tray);
      tray.addEventListener('click', function (e) {
        var rm = e.target.closest('[data-sp-rm]');
        if (rm) { var it = read(COMPARE).filter(function (x) { return x.variantId === rm.dataset.spRm; })[0]; if (it) appToggle(it, 'compare'); return; }
        if (e.target.closest('[data-sp-tray-x]')) { try { sessionStorage.setItem('sp-tray-hide', String(read(COMPARE).length)); } catch (err) {} renderTray(); return; }
        if (e.target.closest('[data-sp-tray-open]')) { e.preventDefault(); openDrawer('compare'); }
      });
    }
    tray.hidden = !show;
    document.documentElement.classList.toggle('sp-tray-on', show);
    if (!show) return;
    var slots = '';
    for (var i = 0; i < MAX_COMPARE; i++) {
      var x = list[i];
      slots += x
        ? '<span class="sp-slot is-filled" title="' + esc(x.productTitle || '') + '">' + (x.imageUrl ? '<img src="' + esc(img(x.imageUrl, 120)) + '" alt="' + esc(x.productTitle || '') + '" width="52" height="52">' : '') +
          '<button type="button" data-sp-rm="' + esc(x.variantId) + '" aria-label="Remove ' + esc(x.productTitle || 'item') + ' from compare">×</button></span>'
        : '<span class="sp-slot" aria-hidden="true">+</span>';
    }
    var ready = list.length >= 2;
    tray.innerHTML =
      '<a class="sp-tray__label" href="#" data-sp-tray-open><b>Compare ' + list.length + '/' + MAX_COMPARE + '</b><small>' + (ready ? 'Ready side by side' : 'Add one more to compare') + '</small></a>' +
      '<div class="sp-slots">' + slots + '</div>' +
      '<a class="sp-btn" href="/pages/compare" data-sp-tray-open' + (ready ? '' : ' aria-disabled="true"') + '>Compare' + (ready ? ' now' : '') + '</a>' +
      '<button type="button" class="sp-tray__x" data-sp-tray-x aria-label="Hide compare tray">×</button>';
    tray.querySelector('.sp-tray__label').style.cssText = 'color:inherit;text-decoration:none';
  }


  /* ---------- Sold out -> Notify me ----------
     Disabled "Sold out" add-to-cart buttons are swapped for a Notify me button that opens
     the app's own back-in-stock alert. The theme button stays in the page (hidden) so the
     theme can still switch it back to "Add to cart" when a different variant is in stock. */
  var BELL = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 10a6 6 0 1 1 12 0c0 4.5 1.6 6 2.5 7H3.5C4.4 16 6 14.5 6 10Z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M9.8 20a2.3 2.3 0 0 0 4.4 0" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
  function isSoldOut(b) { return b.disabled && /sold\s*out/i.test(b.textContent || ''); }
  function cents(t) { var m = String(t || '').replace(/,/g, '').match(/(\d+(?:\.\d{1,2})?)/); return m ? Math.round(parseFloat(m[1]) * 100) : 0; }
  /* Never touch anything the Great Lakes Deposits order builder / pre-order logic controls. */
  function ownedByDeposits(b, form) {
    if (b.hidden || b.getAttribute('aria-hidden') === 'true') return true;
    if (form.closest('[data-gllf-lifecycle-owned], [data-gllf-order-builder]')) return true;
    if (form.matches('[data-gllf-delivery-approved], [data-gllf-payment-approved]') || form.querySelector('[data-gllf-delivery-gate]')) return true;
    var sec = form.closest('product-info, .shopify-section');
    if (sec && !form.closest('.card-wrapper, .product-card-wrapper, .card') && sec.querySelector('[data-gllf-order-builder]')) return true;
    var card = form.closest('product-card, .card-wrapper, .product-card, .grid__item, .quick-add-modal');
    if (card && (card.dataset.gllfPreorderOpen === 'true' || card.querySelector('[data-gllf-governed-product-card][data-ordering-status]') && window.GLLFPreorderAvailability && window.GLLFPreorderAvailability.isAuthoritativePreorder(card.querySelector('[data-gllf-governed-product-card]')))) return true;
    return false;
  }
  function productScope(form) {
    if (form.closest('.card-wrapper, .product-card-wrapper, .card, quick-add-modal, .quick-add-modal')) return null;
    return form.closest('product-info, .product__info-wrapper, .product__info-container') ? (form.closest('product-info, .shopify-section') || document) : null;
  }
  function fillNotifyHost(host, form, main) {
    var d = host.dataset, scope = main ? productScope(form) : null;
    var appHost = scope && scope.querySelector('[data-gllf-product-actions]:not(.gllf-notify-host)');
    var vid = (form.querySelector('input[name="id"]') || {}).value || '';
    if (appHost) {
      Object.keys(appHost.dataset).forEach(function (k) { d[k] = appHost.dataset[k]; });
    } else {
      var card = form.closest('.card-wrapper, .product-card-wrapper, .grid__item, li') || form.parentElement;
      var link = card.querySelector('a.product-title[href*="/products/"], a[href*="/products/"]');
      var title = card.querySelector('.product-title, .card__heading a, .card__heading, .card-information__text, h3, h2');
      var pic = card.querySelector('img');
      var price = card.querySelector('.price-item--sale, .price-item--regular, .price-item, .price');
      var pid = (form.querySelector('input[name="product-id"]') || {}).value || '';
      d.productId = pid; d.productGid = pid ? 'gid://shopify/Product/' + pid : '';
      d.productHandle = link ? (link.pathname.split('/products/')[1] || '').split('/')[0] : '';
      d.productTitle = title ? title.textContent.replace(/\s+/g, ' ').trim() : '';
      d.variantTitle = '';
      d.productImage = pic ? (pic.currentSrc || pic.src || '') : '';
      if (!d.productTitle && pic) d.productTitle = pic.alt || '';
      d.priceCents = String(cents(price && price.textContent));
      d.ruleClass = d.ruleClass || 'unknown';
    }
    if (vid) { d.variantId = vid; d.variantGid = 'gid://shopify/ProductVariant/' + vid; }
    d.available = 'false';
  }
  function notifyButtons() {
    document.querySelectorAll('form[action*="/cart/add"] button[name="add"]:not(.gllf-notify-btn)').forEach(function (b) {
      var form = b.closest('form'); if (!form) return;
      var host = b.nextElementSibling && b.nextElementSibling.classList.contains('gllf-notify-host') ? b.nextElementSibling : null;
      var sold = isSoldOut(b) && !ownedByDeposits(b, form);
      if (!sold) {
        b.classList.remove('gllf-notify-orig');
        if (host) host.hidden = true;
        syncAppAlert(form);
        return;
      }
      var main = !!productScope(form);
      if (!host) {
        host = document.createElement('span');
        host.className = 'gllf-notify-host';
        var n = document.createElement('button');
        n.type = 'button';
        n.className = String(b.className).replace(/\bgllf-notify-orig\b/, '') + ' gllf-notify-btn' + (main ? ' gllf-notify-btn--main' : '');
        n.setAttribute('data-gllf-alert', '');
        n.setAttribute('aria-haspopup', 'dialog');
        n.innerHTML = BELL + '<span>' + (main ? 'Notify me when available' : 'Notify me') + '</span>';
        /* The app reads product data from the closest [data-gllf-product-actions]. Only mark our host
           for the moment of the click so other scripts never mistake it for the real product block. */
        n.addEventListener('click', function () {
          fillNotifyHost(host, form, main);
          host.setAttribute('data-gllf-product-actions', '');
          setTimeout(function () { host.removeAttribute('data-gllf-product-actions'); }, 0);
        }, true);
        host.appendChild(n);
        b.insertAdjacentElement('afterend', host);
      }
      host.hidden = false;
      b.classList.add('gllf-notify-orig');
      syncAppAlert(form);
    });
  }
  /* On the product page, hide the app's separate "Notify me" link while the main button already does it. */
  function syncAppAlert(form) {
    var scope = productScope(form); if (!scope) return;
    var on = !!scope.querySelector('.gllf-notify-host:not([hidden])');
    scope.querySelectorAll('[data-gllf-product-actions]:not(.gllf-notify-host) [data-gllf-alert]').forEach(function (a) { a.classList.toggle('gllf-notify-dup', on); });
  }


  /* ---------- design-v1: wishlist fixes ---------- */
  function gidV(v) { v = String(v || ''); return /^\d+$/.test(v) ? 'gid://shopify/ProductVariant/' + v : v; }
  function hostOf(el) { return el && el.closest && el.closest('[data-gllf-product-actions]'); }
  function inList(key, id) { return read(key).some(function (x) { return gidV(x.variantId) === gidV(id); }); }

  /* 1) Product page: Save/Compare must record the option selected right now. The app only swaps the
     variant id when the option changes, so the name, price, picture and stock were the first option's. */
  var productJson = {};
  function loadProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (!productJson[handle]) productJson[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; }).then(function (j) { productJson[handle] = j || null; return j; }).catch(function () { productJson[handle] = null; return null; });
    return Promise.resolve(productJson[handle]);
  }
  function selectedVariant(host) {
    var scope = host.closest('product-info, [data-product-id], .shopify-section') || document;
    var input = scope.querySelector('form[action*="/cart/add"] [name="id"], .product-variant-id');
    var fromUrl = /[?&]variant=(\d+)/.exec(location.search);
    return (input && input.value) || (fromUrl && !host.closest('.card-wrapper, .card') ? fromUrl[1] : '') || String(host.dataset.variantGid || host.dataset.variantId || '').replace(/\D/g, '');
  }
  function syncVariantData(host) {
    if (!host || host.closest('.card-wrapper, .card, .gllf-notify-host') || host.hidden) return;
    var p = productJson[host.dataset.productHandle]; if (!p || !p.variants) return;
    var id = selectedVariant(host), v = p.variants.filter(function (x) { return String(x.id) === String(id); })[0]; if (!v) return;
    var d = host.dataset;
    d.variantId = String(v.id); d.variantGid = 'gid://shopify/ProductVariant/' + v.id;
    d.variantTitle = v.title || ''; d.priceCents = String(v.price); d.available = String(!!v.available);
    var pic = (v.featured_image && v.featured_image.src) || p.featured_image || '';
    if (pic) d.productImage = String(pic).indexOf('//') === 0 ? 'https:' + pic : pic;
  }
  function primeVariants() {
    document.querySelectorAll('[data-gllf-product-actions][data-product-handle]').forEach(function (h) {
      if (h.closest('.card-wrapper, .card, .gllf-notify-host')) return;
      loadProduct(h.dataset.productHandle).then(function () { syncVariantData(h); });
    });
  }
  document.addEventListener('change', function (e) {
    if (!e.target.closest || !e.target.closest('variant-selects, variant-radios, .product-form__input, form[action*="/cart/add"], product-info')) return;
    setTimeout(function () { document.querySelectorAll('[data-gllf-product-actions]').forEach(syncVariantData); }, 60);
  });

  /* 2) Compare is full: ask which one to swap out instead of silently dropping the oldest. */
  var pass = false;
  function compareFull(btn) {
    var list = read(COMPARE), host = hostOf(btn), snap = {};
    Object.keys(host.dataset).forEach(function (k) { snap[k] = host.dataset[k]; });
    var dlg = document.createElement('dialog'); dlg.className = 'sp-full';
    dlg.innerHTML = '<form method="dialog"><button type="button" class="sp-x" data-close aria-label="Close">×</button>' +
      '<h2>Compare holds ' + MAX_COMPARE + '</h2><p>Choose one to swap out for <b>' + esc(host.dataset.productTitle || 'this product') + '</b>.</p>' +
      '<ul role="list">' + list.map(function (x) {
        return '<li><button type="button" class="sp-full__pick" data-swap="' + esc(x.variantId) + '">' + (x.imageUrl ? '<img src="' + esc(img(x.imageUrl, 120)) + '" alt="" width="56" height="56">' : '<span class="sp-full__ph"></span>') +
          '<span><b>' + esc(x.productTitle || 'Product') + '</b><small>' + (x.variantTitle && x.variantTitle !== 'Default Title' ? esc(x.variantTitle) + ' · ' : '') + money(x.priceCents) + '</small></span><em>Swap out</em></button></li>';
      }).join('') + '</ul><div class="sp-full__foot"><a class="sp-btn sp-btn--ghost" href="/pages/compare">Compare these ' + MAX_COMPARE + ' now</a><button type="button" class="sp-link-btn sp-link-btn--quiet" data-close>Keep my list</button></div></form>';
    document.body.appendChild(dlg);
    dlg.addEventListener('close', function () { dlg.remove(); var back = btn.isConnected ? btn : (root && !root.hidden && root.querySelector('[data-sp-tab][aria-selected="true"]')); if (back && back.focus) back.focus(); });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.closest('[data-close]')) { dlg.close(); return; }
      var pick = e.target.closest('[data-swap]'); if (!pick) return;
      var old = read(COMPARE).filter(function (x) { return x.variantId === pick.dataset.swap; })[0];
      dlg.close(); if (!old) return;
      appToggle(old, 'compare');
      setTimeout(function () {
        pass = true;
        if (btn.isConnected) btn.click();
        else appToggle({ productId: snap.productGid || snap.productId, variantId: snap.variantGid || snap.variantId, productHandle: snap.productHandle, productTitle: snap.productTitle, variantTitle: snap.variantTitle, imageUrl: snap.productImage, priceCents: snap.priceCents, ruleClass: snap.ruleClass, available: snap.available !== 'false' }, 'compare');
        pass = false;
      }, 120);
    });
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
    var first = dlg.querySelector('[data-swap]'); if (first) first.focus();
  }

  /* 3) One capture listener in front of the app's own click handler. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-gllf-save], [data-gllf-compare]');
    var host = hostOf(b); if (!host) return;
    if (!host.closest('.card-wrapper, .card')) syncVariantData(host);
    var id = host.dataset.variantGid || host.dataset.variantId, compare = b.hasAttribute('data-gllf-compare');
    if (compare && !pass && !inList(COMPARE, id) && read(COMPARE).length >= MAX_COMPARE) {
      e.preventDefault(); e.stopImmediatePropagation(); compareFull(b); return;
    }
    if (compare) return;
    var was = inList(KEY, id), snap = {};
    Object.keys(host.dataset).forEach(function (k) { snap[k] = host.dataset[k]; });
    setTimeout(function () {
      var now = inList(KEY, id); if (now === was || !window.GLLFBoards) return;
      window.GLLFBoards.onSaveToggle(snap, now);
    }, 0);
  }, true);

  /* ---------- Boot ---------- */
  /* ---------- gllf-ui-polish-v1: one icon set everywhere ----------
     The app, header, mega menu and cards all draw the same two SVG paths; swap them in place
     so every heart/compare icon on the site matches (desktop, mobile menu, cards, search). */
  var OLD_HEART = 'M20.8 4.7a5.5 5.5', OLD_COMPARE = 'M7 3v18M17 3v18';
  function upgradeIcons(scope) {
    (scope || document).querySelectorAll('svg path[d^="' + OLD_HEART + '"], svg path[d^="' + OLD_COMPARE + '"]').forEach(function (p) {
      var svg = p.closest('svg'); if (!svg || svg.getAttribute('data-gllf-icon-v')) return;
      var heart = p.getAttribute('d').indexOf(OLD_HEART) === 0;
      svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('fill', 'none'); svg.setAttribute('stroke', 'currentColor');
      svg.setAttribute('stroke-width', '1.8'); svg.setAttribute('stroke-linecap', 'round'); svg.setAttribute('stroke-linejoin', 'round');
      svg.innerHTML = heart ? '<path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/>' : '<rect x="3" y="4" width="7.5" height="16" rx="2"/><rect x="13.5" y="4" width="7.5" height="16" rx="2"/><path d="M6 9h1.5M6 12.5h1.5M16.5 9H18M16.5 12.5H18"/>';
      svg.setAttribute('data-gllf-icon-v', heart ? 'heart-2' : 'compare-2');
      svg.classList.add(heart ? 'gllf-i-heart' : 'gllf-i-compare');
    });
  }
  window.GLLFUpgradeIcons = upgradeIcons;
  function refresh(bump) { syncBadges(bump); renderTray(); if (root && !root.hidden) render(); }
  function boot() {
    upgradeIcons(document); initHeader(); decorateButtons(); notifyButtons(); initToasts(); refresh(false); primeVariants();
    var pending = false;
    new MutationObserver(function (muts) {
      if (pending) return;
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes.length) {
          pending = true;
          requestAnimationFrame(function () { pending = false; upgradeIcons(document); decorateButtons(); notifyButtons(); initHeader(); primeVariants(); });
          break;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  document.addEventListener('gllf:saved:changed', function () { setTimeout(function () { refresh(true); }, 0); });
  window.addEventListener('storage', function (e) { if (e.key === KEY || e.key === COMPARE) refresh(true); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () { upgradeIcons(document); initHeader(); decorateButtons(); notifyButtons(); });
  document.addEventListener('change', function (e) { if (e.target.closest('variant-selects, variant-radios, .product-form__input, form[action*="/cart/add"]')) setTimeout(notifyButtons, 350); });
})();
